import { NextPageContext } from 'next';
import { NextRequest } from 'next/server';

export const getDomainNameFromHostname = (hostname?: string) => {
  const environment = process.env.ENVIRONMENT;
  return environment !== 'local' && environment !== 'test'
    ? (hostname ?? '')
    : `${process.env.LOCAL_MICROSITE}`;
};

export const getDomainNameFromContext = (ctx: NextPageContext) =>
  getDomainNameFromHostname(ctx.req?.headers.host);

export const getDomainNameFromRequest = (req: NextRequest) =>
  getDomainNameFromHostname(req?.headers.get('host') ?? undefined);
